// extracted by mini-css-extract-plugin
module.exports = {"attributions":"Attributions-module--attributions--1MTay"};